import { animate, state, style, transition, trigger, keyframes } from '@angular/animations';

export const FADE_IN_RIGHT_BIG =
	trigger('fadeInRightBig', [
		state('on', style({
            transform: 'none',
			opacity: 1
		})),
		state('off',   style({
            transform: 'translate3d(-100vw, 0, 0)',
			opacity: 1
		})),
		state('off_left',   style({
            transform: 'translate3d(100vw, 0, 0)',
			opacity: 0
		})),
		transition('on => off_left', animate('1s linear')),
		transition('on => off', animate('1s linear')),
		transition('off => on', animate('1s linear', keyframes(
			[
				style({transform: 'translate3d(100vw, 0, 0)', offset: 0}),
				style({transform: 'none', opacity: 1,  offset: 1.0})
			]
		))),
		transition('off_left => on', animate('1s linear', keyframes(
			[
				style({transform: 'translate3d(100vw, 0, 0)', offset: 0}),
				style({transform: 'none', opacity: 1,  offset: 1.0})
			]
		)))
    ]); 

export const FADE_IN_LEFT_BIG =
	trigger('fadeInLeftBig', [
		state('on', style({
            transform: 'none',
            opacity: 1
		})),
		state('off',   style({
            transform: 'translate3d(100vw, 0, 0)',
            opacity: 0
		})),
		state('off_right',   style({
            transform: 'translate3d(-100vw, 0, 0)',
			opacity: 0
		})),
		transition('on => off_right', animate('1s linear')),
		transition('on => off', animate('1s linear')),
		transition('off => on', animate('1s linear', keyframes(
			[
				style({transform: 'translate3d(-100vw, 0, 0)', offset: 0}),
				style({transform: 'none', opacity: 1,  offset: 1.0})
			]
		))),
		transition('off_right => on', animate('1s linear', keyframes(
		[
			style({transform: 'translate3d(-100vw, 0, 0)', offset: 0}),
			style({transform: 'none', opacity: 1,  offset: 1.0})
		]
		)))
    ]); 

export const FADE_IN_TOP_BIG = 
	trigger('fadeInTopBig', [
		state('on', style({
		transform: 'none',
		opacity: 1
		})),
		state('off',   style({
		transform: 'translate3d(0,2000px, 0)',
		opacity: 0
		})),
	transition('on => off', animate('1s ease-out')),
	transition('off => on', animate('1s ease-in', keyframes(
		[
			style({transform: 'translate3d(0, -2000px, 0)', offset: 0}),
			style({transform: 'none', opacity: 1,  offset: 1.0})
		]
	)))
]); 
